import { type CUSTOMER_DATA_TAB, CUSTOMER_DATA_TABS, type OVERVIEW_TAB, OVERVIEW_TABS } from 'cpool-constants';

import {
    BUILDING_DESCRIPTION_STEP_IDS,
    BUILDING_DESCRIPTION_STEP_PATHS,
    type BuildingDescriptionStepId,
    type BuildingDescriptionStepPath,
    DEFAULT_BUILDING_DESCRIPTION_STEP_ID,
} from '../components/Overview/CustomerData/RealEstates/BuildingDescription/types';
import {
    CREATE_APPLICANT_TAB_PATHS,
    type CreateApplicantTab,
    type CreateApplicantTabPath,
    type CUSTOMER_DATA_TAB_PATH,
    CUSTOMER_DATA_TAB_PATHS,
    OVERVIEW_TAB_PATHS,
} from '../constants/tabPaths';

export const getCustomerDataTabFromPath = (path: string): CUSTOMER_DATA_TAB | null => {
    switch (path) {
        case CUSTOMER_DATA_TAB_PATHS[CUSTOMER_DATA_TABS.EMPLOYMENT]:
            return CUSTOMER_DATA_TABS.EMPLOYMENT;
        case CUSTOMER_DATA_TAB_PATHS[CUSTOMER_DATA_TABS.INCOME_AND_EXPENSES]:
            return CUSTOMER_DATA_TABS.INCOME_AND_EXPENSES;
        case CUSTOMER_DATA_TAB_PATHS[CUSTOMER_DATA_TABS.LIVING_SITUATION]:
            return CUSTOMER_DATA_TABS.LIVING_SITUATION;
        case CUSTOMER_DATA_TAB_PATHS[CUSTOMER_DATA_TABS.PERSONAL_DATA]:
            return CUSTOMER_DATA_TABS.PERSONAL_DATA;
        case CUSTOMER_DATA_TAB_PATHS[CUSTOMER_DATA_TABS.REAL_ESTATE]:
            return CUSTOMER_DATA_TABS.REAL_ESTATE;
        default:
            return null;
    }
};

export const getCreateApplicantTabFromPath = (path?: string): CreateApplicantTab => {
    switch (path) {
        case CREATE_APPLICANT_TAB_PATHS.EMPLOYMENT:
            return 'EMPLOYMENT';
        case CREATE_APPLICANT_TAB_PATHS.EXISTING_CREDITS:
            return 'EXISTING_CREDITS';
        case CREATE_APPLICANT_TAB_PATHS.INCOME_AND_EXPENSES:
            return 'INCOME_AND_EXPENSES';
        case CREATE_APPLICANT_TAB_PATHS.LIVING_SITUATION:
            return 'LIVING_SITUATION';
        case CREATE_APPLICANT_TAB_PATHS.REAL_ESTATE:
            return 'REAL_ESTATE';
        default:
            return 'PERSONAL_DATA';
    }
};

export const getBuildingDescriptionStepFromPath = (path?: string): BuildingDescriptionStepId => {
    const step = BUILDING_DESCRIPTION_STEP_IDS.find((id) => BUILDING_DESCRIPTION_STEP_PATHS[id] === path);
    return step ?? DEFAULT_BUILDING_DESCRIPTION_STEP_ID;
};

export const isBuildingDescriptionStepPath = (path: string): path is BuildingDescriptionStepPath =>
    BUILDING_DESCRIPTION_STEP_IDS.some((id) => BUILDING_DESCRIPTION_STEP_PATHS[id] === path);

export const isCustomerDataTabPath = (path: string): path is CUSTOMER_DATA_TAB_PATH =>
    getCustomerDataTabFromPath(path) !== null;

export const isCreateApplicantTabPath = (path: string): path is CreateApplicantTabPath =>
    Object.values(CREATE_APPLICANT_TAB_PATHS).some((tabPath) => tabPath === path);

export const getOverviewTabFromPathname = (pathname: string): OVERVIEW_TAB => {
    if (pathname.includes(`/${OVERVIEW_TAB_PATHS[OVERVIEW_TABS.BANK_REQUEST]}`)) return OVERVIEW_TABS.BANK_REQUEST;
    if (pathname.includes(`/${OVERVIEW_TAB_PATHS[OVERVIEW_TABS.DOCUMENT_CENTER]}`))
        return OVERVIEW_TABS.DOCUMENT_CENTER;
    if (pathname.includes(`/${OVERVIEW_TAB_PATHS[OVERVIEW_TABS.HISTORY]}`)) return OVERVIEW_TABS.HISTORY;
    if (pathname.includes(`/${OVERVIEW_TAB_PATHS[OVERVIEW_TABS.OFFER_MANAGEMENT]}`))
        return OVERVIEW_TABS.OFFER_MANAGEMENT;
    return OVERVIEW_TABS.CUSTOMER_DATA;
};
